
<template>
  <div class="reports">
    <h1>Reports<span class="h1-underline"></span></h1>
    <FiltersReport />
    <v-card>
      <v-card-title class="">
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="dados"
        :search="search"
      ></v-data-table>
    </v-card>
    <v-btn
      :loading="loading5"
      :disabled="loading5"
      color="blue-grey"
      class="ma-2 white--text"
      fab
      @click="loader = 'loading5'"
    >
      <v-icon dark>mdi-cloud-download</v-icon>
    </v-btn>
  </div>
</template>

<script>
import FiltersReport from '@/components/Filters_Report';
export default {
  components: {
    FiltersReport
  },
  name: 'Reports',
    data () {
      return {
        search: '',
        headers: [
          {
            text: '',
            align: 'left',
            value: 'visualização',
          },
          { text: '-', align: 'center', value: 'nova-lead-por-contactar', sortable:false},
          { text: 'Incontactável', align: 'center', value: 'nova-lead-incontactável', sortable:false },
          { text: 'Não Atende', align: 'center', value: 'lead-nao-atende', sortable:false },
          { text: 'Inválido', align: 'center', value: 'nova-lead-invalido', sortable:false },
          { text: 'Insucesso', align: 'center', value: 'nova-lead-insucesso', sortable:false },
          { text: 'Aguarda Documentos', align: 'center', value: 'nova-lead-aguarda-doc', sortable:false },
          { text: 'Aguarda Documentos', align: 'center', value: 'doc-aguarda-doc', sortable:false },
          { text: 'Aguarda Decisão Parceiros', align: 'center', value: 'doc-aguarda-decisao-parceiros', sortable:false },
          { text: 'Não Atende', align: 'center', value: 'doc-nao-atende', sortable:false },
          { text: 'Insucesso', align: 'center', value: 'doc-insucesso', sortable:false },
          { text: 'Aguarda Submissão', align: 'center', value: 'parceiros-aguarda-submissão', sortable:false },
          { text: 'Aguarda Documentação Complementar', align: 'center', value: 'parceiros-aguarda-doc-complementar', sortable:false },
          { text: 'Aguarda Decisão Parceiros', align: 'center', value: 'parceiros-aguarda decisao-parceiros', sortable:false },
          { text: 'Aguarda Devolução Contrato', align: 'center', value: 'parceiros-aguarda-devolucao-contrato', sortable:false },
          { text: 'Aguarda Financiamento', align: 'center', value: 'parceiros-aguarda-financiamento', sortable:false },
          { text: 'Insucesso', align: 'center', value: 'parceiros-insucesso', sortable:false },


        ],
        
        dados: [
          {
            name: 'Frozen Yogurt',
            calories: 159,
            fat: 6.0,
            carbs: 24,
            protein: 4.0,
            iron: '1%',
          },
          {
            name: 'Ice cream sandwich',
            calories: 237,
            fat: 9.0,
            carbs: 37,
            protein: 4.3,
            iron: '1%',
          },
          {
            name: 'Eclair',
            calories: 262,
            fat: 16.0,
            carbs: 23,
            protein: 6.0,
            iron: '7%',
          },
        ],
        loader: null,
        loading: false,
        loading2: false,
        loading3: false,
        loading4: false,
        loading5: false,
      }
    },
    watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 3000)

        this.loader = null
      },
    },
  }
</script>

<style scoped>
    h1{
      margin-left: 296px;
      color: black;
      font-size: 20px;
      text-transform: uppercase;
      margin-top: 50px;
      position: relative;
      display: block;
    }
    .h1-underline{
      position: absolute;
      left: 0;
      bottom: 0;
      width: 60px;
      height: 3px;
      background-color: black;
      margin-bottom: -6px;
    }
    .v-card{
        margin: 10px 40px 50px 296px;
        padding: 40px;
        padding-top:10px;

    
    }
    .v-card__title{
        margin-bottom: 50px;
    }

    .v-btn{
      margin-left: 330px!important;
      margin-top: -120px!important;
      width: 70px;
      height: 70px;
      background-color:rgb(246, 147, 30)!important;
    }
    .v-btn i{
      font-size:30px!important;
    }

    .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

</style>>
   